import { render } from "./Login.vue?vue&type=template&id=7c0a8cb2"
import script from "./Login.vue?vue&type=script&lang=js"
export * from "./Login.vue?vue&type=script&lang=js"
script.render = render

export default script